import React from 'react'
import Icon from '../index'

const VideoIcon = ({ color, size }: any) => (
  <Icon color={color} size={size}>
    <path d="M12,4.33333333 L12,2.0085302 C12,0.901950359 11.1007504,2.09620418e-14 9.9914698,1.84120759e-14 L2.0085302,6.12422144e-17 C0.901950359,-2.4825153e-15 0,0.899249601 0,2.0085302 L0,9.9914698 C0,11.0980496 0.899249601,12 2.0085302,12 L9.9914698,12 C11.0980496,12 12,11.1007504 12,9.9914698 L12,7.66666667 L14.4704221,9.72535177 C15.3117237,10.4264364 16,10.1047419 16,9.00038502 L16,2.99961498 C16,1.88743329 15.3151847,1.57067945 14.4704221,2.27464823 L12,4.33333333 Z" />
  </Icon>
)

VideoIcon.propTypes = {
  ...Icon.propTypes,
}

export default VideoIcon
